import { Controller } from "@hotwired/stimulus"
import { shouldActivateClickEvent } from "../../../utils/keyboardAccessibility"

export default class extends Controller {
  static targets = ["modal", "itemTitle", "form"]

  open(event) {
    if (!this.shouldActivate(event)) return

    event.preventDefault()
    event.stopPropagation()

    if (this.hasItemTitleTarget) {
      this.itemTitleTarget.textContent = event.params.title || ""
    }

    if (this.hasFormTarget && event.params.url) {
      this.formTarget.action = event.params.url
    }

    this.modalController()?.show(event)
  }

  // ponytail: UI-only demos pass url "#"; INT-3 / quiz-results use real todo_item_path.
  confirm(event) {
    if (!this.hasFormTarget) return

    if (this.isDemoRemoveUrl(this.formTarget.getAttribute("action"))) {
      event.preventDefault()
      this.close(event)
    }
  }

  isDemoRemoveUrl(url) {
    return !url || url === "#"
  }

  shouldActivate(event) {
    return shouldActivateClickEvent(event)
  }

  close(event) {
    this.modalController()?.close(event)
  }

  modalController() {
    const modalRoot = this.hasModalTarget
      ? this.modalTarget
      : document.getElementById("remove-todo-confirmation-modal")

    if (!modalRoot) return null

    return this.application.getControllerForElementAndIdentifier(modalRoot, "railsui-modal")
  }
}
